import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'nns-note-actions',
  template: `
  <div class="note-action-holder" flex="none"
    *ngIf="attachments.length"
  >
    <div class="note-action nns-animated toggle-attachments"
      (click)="clickAttachments()"
      [ngClass]="{'note-action-active' : attachmentsActive}"
    >
      <span class="note-action-layout" flex="none" layout="row" layout-align="start center">
        <span class="note-action-count" flex="none">
          <span class="note-action-count-shape" flex="none"
                layout="row" layout-align="center center">{{attachments.length}}</span>
        </span>
        <span class="note-action-text">Files</span>
      </span>
    </div>
  </div>

  <div class="note-action-holder" flex="none"
    *ngIf="todosUnchecked?.length"
  >
    <div class="note-action nns-animated toggle-todo"
      (click)="clickTodos()"
    >
      <span class="note-action-layout" flex="none" layout="row" layout-align="start center">
        <span class="note-action-count" flex="none">
          <span class="note-action-count-shape"
            flex="none" layout="row" layout-align="center center">{{todosUnchecked.length}}</span>
        </span>
        <span class="note-action-text">To-do</span>
      </span>
    </div>
  </div>
  `,
  styles: [`
    .note-action-holder {
      padding:0 8px;
    }
    .note-action {
      display:block;
      cursor:pointer;
      background:none;
      border:none;
      color:rgba(0,0,0, 0.8);
      font-size:14px;
      line-height:1;
      padding:8px;
      font-weight:bold;
      text-transform:uppercase;
      border-radius:2px;
    }
    .note-action .note-action-count {
      margin:0 8px 0 0;
    }
    .note-action .note-action-count-shape {
      background:#1F95A7;
      border-radius:2px;
      min-width:24px;
      height:24px;
      padding:0 4px;
      text-align:center;
      color:#fff;
      font-weight:bold;
      font-size:16px;
    }

    .note-action-active {background:#EBEFF1;}
  `,`
    :host-context(.nns-theme-night) .note-action {
      color:#fff;
    }
    :host-context(.nns-theme-night) .note-action-active {
      background:rgba(181,181,181,0.10);
    }
    `]
})
export class NoteActionsComponent implements OnInit {
  @Input() attachments;
  @Input() todos;
  @Input() note;
  @Output() attachmentsToggled = new EventEmitter();
  @Output() todosToggled = new EventEmitter();
  todosChecked;
  todosUnchecked;

  attachmentsActive = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.todos) {
      this.todosChecked = this.todos.filter((x) => !!x.checked);
      this.todosUnchecked = this.todos.filter((x) => !x.checked);
    }
  }

  ngOnInit() {
    if (this.note.isVideoNote || this.note.isImageNote) {
      this.attachmentsActive = false;
    }
    this.emitOutput();
  }

  clickAttachments() {
    this.attachmentsActive = !this.attachmentsActive;
    this.emitOutput();
  }

  clickTodos() {
    this.todosToggled.emit(true);
  }

  emitOutput() {
    this.attachmentsToggled.emit(this.attachmentsActive);
  }
}
